/**
 * HelplineSOS REST API Service - DEV
 * HelplineSOS REST API Service - Hosted on AWS ECS Cluster - DEV Environment Last Updated On Mon, 7 Sep 2020 17:23:26 EST
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContactUsDTO } from '../model/contactUsDTO';
import { NotificationDTO } from '../model/notificationDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NotificationControllerService {

    protected basePath = 'https://api-dev.helplinesos.org';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Clear A Notification
     * Clear&#39;s A Notification
     * @param notificationId notificationId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearNotificationUsingPOST(notificationId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public clearNotificationUsingPOST(notificationId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public clearNotificationUsingPOST(notificationId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public clearNotificationUsingPOST(notificationId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (notificationId === null || notificationId === undefined) {
            throw new Error('Required parameter notificationId was null or undefined when calling clearNotificationUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/notifications/clear/${encodeURIComponent(String(notificationId))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Clear All Notification(s)
     * Clear&#39;s All Notification(s)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearNotificationsUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public clearNotificationsUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public clearNotificationsUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public clearNotificationsUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/api/notifications/clear`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Contact HelplineSOS
     * Send&#39;s Email to HelplineSOS
     * @param contactUsDTO contactUsDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contactUsUsingPOST(contactUsDTO: ContactUsDTO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public contactUsUsingPOST(contactUsDTO: ContactUsDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public contactUsUsingPOST(contactUsDTO: ContactUsDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public contactUsUsingPOST(contactUsDTO: ContactUsDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (contactUsDTO === null || contactUsDTO === undefined) {
            throw new Error('Required parameter contactUsDTO was null or undefined when calling contactUsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/notifications/contact`,
            contactUsDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Notification(s)
     * Get&#39;s Notification(s)
     * @param notificationStateType notificationStateType
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNotificationsUsingGET(notificationStateType: 'NEW' | 'OLD' | 'ALL', observe?: 'body', reportProgress?: boolean): Observable<Array<NotificationDTO>>;
    public getNotificationsUsingGET(notificationStateType: 'NEW' | 'OLD' | 'ALL', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NotificationDTO>>>;
    public getNotificationsUsingGET(notificationStateType: 'NEW' | 'OLD' | 'ALL', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NotificationDTO>>>;
    public getNotificationsUsingGET(notificationStateType: 'NEW' | 'OLD' | 'ALL', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (notificationStateType === null || notificationStateType === undefined) {
            throw new Error('Required parameter notificationStateType was null or undefined when calling getNotificationsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NotificationDTO>>(`${this.basePath}/api/notifications/${encodeURIComponent(String(notificationStateType))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
